export default __webpack_public_path__ + "static/media/img1.3cb3af46.png";